module.exports = __webpack_public_path__ + "static/media/box-ok-kn.15d04790.svg";